module.exports = __webpack_public_path__ + "static/media/BROKER_PAGE.2390a5af.png";